/* eslint-disable no-param-reassign */
import { RefObject, useEffect } from "react"

interface UseAutosizeTextAreaProps {
  ref: RefObject<HTMLTextAreaElement | null>
  containerRef: RefObject<HTMLDivElement | null>
}

export function useAutosizeTextArea({
  ref,
  containerRef
}: UseAutosizeTextAreaProps) {
  useEffect(() => {
    if (ref?.current) {
      ref.current.style.height = "0px"
      const { scrollHeight } = ref.current
      const containerHeight =
        containerRef.current?.getBoundingClientRect().height || 0
      ref.current.style.height = `${Math.max(
        scrollHeight + 1,
        containerHeight
      )}px`
    }
  })
}
